import React, { useState, useRef, useEffect } from "react";
import { AiOutlineClose } from "react-icons/ai";
import { HiChevronDoubleDown, HiChevronDoubleRight } from "react-icons/hi";
import { Button, Col, Row, Container, Modal } from "react-bootstrap";
import { FaTwitter, FaInstagram, FaYoutube, FaTwitch } from "react-icons/fa";
import { usePlayers } from "../api/DataContext";
import { GiCrown } from "react-icons/gi";
import { AiOutlineDoubleRight } from "react-icons/ai";
import { useLocation, NavLink } from "react-router-dom";
export default function Community() {
  const location = useLocation();
  const { winners, isLoading } = usePlayers();
  const [finalWinners, setFinalWinners] = useState(winners);
  const rewardPos = useRef(null);
  useEffect(() => {
    setFinalWinners(winners);
  }, [winners]);
  const wolRef = useRef(null);

  const winnerRef = useRef(null);
  const monthref = useRef(null);

  const [cwinner, setcwinner] = useState("");
  const [modalbool, setmodalbool] = useState(false);

  const modalData = (winner) => {
    setmodalbool(true);
    setcwinner(winner);
  };
  const searchWinner = () => {
    let q = winnerRef.current.value;
    const startsWith = winners.filter((x) =>
      x.name.toLowerCase().includes(q.toLowerCase())
    );
    setFinalWinners(startsWith);
  };
  useEffect(() => {
    if (location.hash === "") window.scrollTo(0, 0);
  }, [location]);
  return (
    <>
      <Container
        fluid
        className="community-bg p-0"
        style={{ height: "100vh", minHeight: "100vh" }}
      >
        <Row className="h-100 g-0">
          <Col className="h-100">
            <section className="  h-100 m-auto d-flex flex-column justify-content-center align-items-start    ">
              <Row className="m-auto h-100 ">
                <Col md={6} className="my-auto text-center px-2">
                  <img
                    alt="upload gameplay"
                    src="https://res.cloudinary.com/zerko/image/upload/v1648837660/upload-gameplay-get-rewarded-trimmy_fmmm5z.webp"
                    className="img-fluid d-md-none mb-5"
                    style={{ width: "60vw" }}
                  />

                  <h2 className="display-4 text-brand text-center text-light fw-bold  zi2 px-2">
                    Zerko Community
                  </h2>

                  <ul className="pt-2  nav fs-5 flex-column justify-content-center  align-items-center text-white">
                    <li className="nav-item link-light text-center py-2 d-flex justify-items-start align-items-center gap-2">
                      {/* <div className="stepIndex">1</div>{" "} */}
                      <span>1. Submit Your Gameplay</span>
                    </li>
                    <HiChevronDoubleDown className="text-brand" />
                    <li className="nav-item link-light text-center py-2 d-flex justify-items-start align-items-center gap-2">
                      {/* <div className="stepIndex">2</div>{" "} */}
                      <span>2. Get Entered Into The Drawing</span>
                    </li>
                    <HiChevronDoubleDown className="text-brand" />
                    <li className="nav-item link-light text-center py-2 d-flex justify-items-start align-items-start gap-2">
                      {/* <div className="stepIndex">3</div>{" "} */}
                      <button
                        type="button"
                        className=" nav-link   px-0 text-center py-2 link-light"
                        onClick={() => monthref.current.scrollIntoView()}
                      >
                        3. Get Selected To Become{" "}
                        <span className=" text-brand d-inline-flex ">
                          <span> Member Of The Month</span>
                        </span>
                      </button>
                    </li>
                    <li className="nav-item p-0 py-3 p-md-3">
                      <button
                        className="shadow btn btn-dark btn-sm btn-know  d-flex justify-content-center align-items-center"
                        onClick={(e) => rewardPos.current.scrollIntoView()}
                      >
                        <span className="px-2">Learn More</span>{" "}
                        <HiChevronDoubleRight />
                      </button>
                    </li>
                  </ul>
                </Col>
                <Col md={6} className="my-auto d-none d-md-block ">
                  <img
                    alt="upload gameplay"
                    src="https://res.cloudinary.com/zerko/image/upload/v1648837660/upload-gameplay-get-rewarded-trimmy_fmmm5z.webp"
                    className="img-fluid upload_img"
                    style={{ width: "48vw" }}
                  />
                </Col>
              </Row>
            </section>
          </Col>
        </Row>
      </Container>

      {/* Community Member of month winner */}
      <Container fluid className="bg-white ">
        <Row className="">
          <Col xs={12} md={6} className="community-bg4" ref={monthref}>
            <Row className="mt-5 pb-5  text-white px-2 px-md-5 ">
              <Col md={12} className="mb-3">
                <h1 className="mt-3  display-6 fs-2 px-2 lh-base fw-normal text-brand text-center ">
                  {" "}
                  <span className=" text-brand d-flex flex-column justify-content-center align-items-center ">
                    <GiCrown className="" />
                    <span>Community Member of the Month </span>
                  </span>
                </h1>
                <div className="monthPlayerCard mt-3">
                  <p className="text-white fs-6 sub-underline">
                    {" "}
                    {winners.length > 0 &&
                      winners[0].date.toDate().toLocaleString("en-us", {
                        month: "long",
                        year: "numeric",
                      })}
                  </p>
                  <div className="d-flex flex-column flex-md-row align-items-start justify-content-center justify-md-content-between mb-2">
                    <h2 className="mt-2 display-6 fs-2 px-2 lh-base text-white fw-normal  headingshadow2">
                      {winners.length > 0 && winners[0].name}
                    </h2>

                    <span className="monthsocials rounded-3 d-flex flex-row m-auto justify-content-md-end align-items-center ">
                      {winners.length > 0 && winners[0].socials.twitter && (
                        <a
                          className="d-flex nav-link my-auto social_link"
                          target="_blank"
                          rel="noreferrer"
                          href={winners[0].socials.twitter}
                        >
                          <FaTwitter size={22} className="" />{" "}
                          <span className="visually-hidden"> Twitter</span>
                        </a>
                      )}
                      {winners.length > 0 && winners[0].socials.Instagram && (
                        <a
                          className="d-flex nav-link my-auto social_link"
                          target="_blank"
                          rel="noreferrer"
                          href={winners[0].socials.instagram}
                        >
                          <FaInstagram size={22} className="" />{" "}
                          <span className="visually-hidden"> Instagram</span>
                        </a>
                      )}
                      {winners.length > 0 && winners[0].socials.youtube && (
                        <a
                          className="d-flex nav-link my-auto social_link"
                          target="_blank"
                          rel="noreferrer"
                          href={winners[0].socials.youtube}
                        >
                          <FaYoutube size={22} className="" />{" "}
                          <span className="visually-hidden"> youtube</span>
                        </a>
                      )}
                      {winners.length > 0 && winners[0].socials.twitch && (
                        <a
                          className="d-flex nav-link my-auto social_link"
                          target="_blank"
                          rel="noreferrer"
                          href={winners[0].socials.twitch}
                        >
                          <FaTwitch size={22} className="" />{" "}
                          <span className="visually-hidden"> Twitch</span>
                        </a>
                      )}
                    </span>
                  </div>

                  <Container className="mx-auto text-center twitch-container rounded-3">
                    <iframe
                      className="w-100 rounded monthvideo"
                      src={winners.length > 0 && winners[0].videoUrl}
                      frameBorder="0"
                      allow="autoplay; encrypted-media"
                      allowFullScreen
                      title="video"
                    />
                  </Container>
                </div>
              </Col>
            </Row>
          </Col>
          <Col xs={12} md={6} className="community-bg5" ref={wolRef}>
            <Row className=" mt-5   text-white px-2 px-md-5 pb-4">
              <Col xs={12} className="my-auto ">
                <h1 className="mt-3  display-6 fs-2 px-2 lh-base fw-normal text-brand text-center">
                  {" "}
                  <span className=" text-brand d-flex flex-column justify-content-center align-items-center ">
                    <GiCrown className="" />
                    <span>Wall Of Legends</span>
                  </span>
                </h1>
              </Col>
              <Col xs={12}>
                <div
                  className="monthPlayerCard mt-3"
                  style={{ background: "#11111199" }}
                >
                  <p className="text-white fs-6  ">
                    <div className="form__group field  pb-3 px-3  w-75 mx-auto ">
                      <input
                        type="input"
                        className="form__field"
                        placeholder="User Name"
                        name="name"
                        id="name"
                        required
                        onChange={() => searchWinner()}
                        ref={winnerRef}
                      />
                      <label htmlFor="name" className="form__label">
                        Search For a Member
                      </label>
                    </div>
                  </p>
                  <div className="wallstats">
                    <div className="d-flex flex-column p-3  mx-auto mx-md-0  wallstats_inner gap-2">
                      {finalWinners.length > 0 &&
                        finalWinners.map((x, index) => {
                          return (
                            <button
                              className="w-100 text-center nav-link wallchoice    fw-bold   px-3 py-1 py-md-3  "
                              onClick={() => modalData(x)}
                              key={index}
                            >
                              {x.name}
                            </button>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>

      <a name="rewardDetails" ref={rewardPos}></a>
      <Container fluid className="bg-brand2 py-5">
        <Row className="mt-5   text-white px-2 px-md-5">
          <Col md={12}>
            <h1 className="my-3 display-6 fs-2  lh-base  fw-normal text-brand ">
              {" "}
              Community Member of the Month
            </h1>
            {/* <h2 className=" mb-5 display-5 text-sm  lh-base fw-normal ">
              Get Rewarded for your Gameplay
            </h2> */}
            <h2 className="mt-3 display-5 fs-4  lh-base fw-bold ">
              Frequently Asked Questions
            </h2>
          </Col>
          <Col md={12}>
            <h1 className="cquestion">How to participate?</h1>
            <p className="   canswer pb-3">
              Join our{" "}
              <a
                rel="noreferrer"
                className="brand-link "
                href="https://discord.gg/ekscSGmg27"
                target="_blank"
              >
                Discord Server
              </a>{" "}
              and share your gameplay in our 'community-member-of-the-month'
              channel with a YouTube link and your socials.
            </p>
          </Col>
          <Col md={12}>
            <h1 className="cquestion">
              When and where will be the winners announced?
            </h1>
            <p className="canswer ">
              We will be announcing the winners every month on the 30th on our
              Discord server & on{" "}
              <a href="/community" className="brand-link">
                zerko.gg/community
              </a>
              .
            </p>
            <p className="canswer pb-3">
              Submissions must be sent in by the 25th of each month for
              reviewal.
            </p>
          </Col>
          <Col md={12}>
            <h1 className="cquestion">What are the Rewards?</h1>
            <p className="canswer ">
              The winner will receive a prime spot on the community tab with
              their clip and socials displayed.
            </p>
            <p className="canswer pb-3">
              Once you win, you always become a winner and join the{" "}
              <a
                className="brand-link"
                onClick={() => wolRef.current.scrollIntoView()}
              >
                Wall Of Legends
              </a>{" "}
              where your information will be on-site and immortalized.
            </p>
          </Col>
        </Row>
      </Container>
      <Modal
        show={modalbool}
        onHide={() => setmodalbool(false)}
        centered
        className="bgprt"
      >
        <div className=" py-5 px-3 px-md-5  d-flex flex-column justify-content-around align-items-center text-white bgwinner shadow-light3">
          <Button
            onClick={() => setmodalbool(false)}
            variant=""
            className="text-white "
            style={{ position: "absolute", right: "10px", top: "10px" }}
          >
            <AiOutlineClose size={24} />
            <span className="visually-hidden">Loading...</span>
          </Button>

          <div>
            {cwinner && cwinner.name && (
              <h4 className="display-6 fs-2 fw-bold text-start">
                {cwinner.name}
              </h4>
            )}
          </div>
          <Container className="mx-auto text-center twitch-container">
            <iframe
              className="w-100 rounded monthvideo"
              src={cwinner.videoUrl}
              frameborder="0"
              allow="autoplay; encrypted-media"
              allowfullscreen
              title="video"
            />
          </Container>

          <span className="d-flex mt-4 ">
            {cwinner.socials && cwinner.socials.youtube && (
              <a
                rel="noreferrer"
                className="d-flex nav-link  my-auto"
                target="_blank"
                href={cwinner.socials.youtube}
              >
                <FaYoutube size={32} className="social_link" />
              </a>
            )}
            {cwinner.socials && cwinner.socials.twitter && (
              <a
                rel="noreferrer"
                className="d-flex nav-link  my-auto"
                target="_blank"
                href={cwinner.socials.twitter}
              >
                <FaTwitter size={32} className="social_link" />
              </a>
            )}
            {cwinner.socials && cwinner.socials.instagram && (
              <a
                rel="noreferrer"
                className="d-flex nav-link  my-auto"
                target="_blank"
                href={cwinner.socials.instagram}
              >
                <FaInstagram size={32} className="social_link" />
              </a>
            )}
          </span>
        </div>
      </Modal>
    </>
  );
}
